import React from 'react';
import ButtonLink from '../ui/Buttons/ButtonLink';
import { GatsbyImage } from "gatsby-plugin-image";
import Section from '../ui/Section/Section';
import Carousel from '../ui/Carousel/Carousel';
import Video from "../Video";
import { IBlockContentReferences, BlockContentReferencesItem } from './IBlocks';
import { cloneDeep } from 'lodash';

type Props = {
    id?: string;
}

export default function ContentReferences (props: Props & IBlockContentReferences) {
    const {references, title, id} = props;

    let items: Array<{top: React.ReactElement, bottom: React.ReactElement}> = [];

    for (const content of references) {

        let data: BlockContentReferencesItem;
        let buttonLabel: string = "Jetzt mehr erfahren";
        if (content?.fallbeispiel) { 
            data = cloneDeep(content.fallbeispiel); 
            data.url = "/fallbeispiele/" + content.fallbeispiel.url 
            buttonLabel = "Zum Fallbeispiel";
        }
        if (content?.produkt) { 
            data = cloneDeep(content.produkt); 
            data.url = "/produkte/" + content.produkt.url 
            buttonLabel = "Zum Produkt";
        }
        if (content?.material) { 
            data = cloneDeep(content.material); 
            data.url = "/leistungen/materialien/" + content.material.url;
        }
        if (content?.weiterverarbeitung) { 
            data = cloneDeep(content.weiterverarbeitung); 
            data.url = "/leistungen/weiterverarbeitung/" + content.weiterverarbeitung.url 
        }
        if (content?.druckverfahren) { 
            data = cloneDeep(content.druckverfahren); 
            data.url = "/leistungen/druckverfahren/" + content.druckverfahren.url 
        }
        if (content?.landingpage) { 
            data = cloneDeep(content.landingpage); 
            data.url = "/" + content.landingpage.url 
        }

        if (content?.video) { 
            data = content.video;

            items.push({
                top: <div key={data.url}>
                        <Video src={"https://www.youtube.com/embed/" + content.video.video} image={data.listenbild} />
                    </div>,
                bottom: <div key={data.url}>
                    <h3 className="title is-4">{content.title ? content.title : data.name}</h3>
                    <p>{content.kurzbeschreibung ? content.kurzbeschreibung : data.kurzbeschreibung}</p>
                </div>,
            });
            continue;
        }

        if (data && references.length > 1) {
            items.push({
                top: <div key={data.url}>
                        <GatsbyImage
                            image={{...data.listenbild.src.childImageSharp.gatsbyImageData, aspectRatio: 1.6 }}
                            alt={data.listenbild.alt}
                            title={data.listenbild.alt} />
                    </div>,
                bottom: <div key={data.url}>
                    <h3 className="title is-4">{content.title ? content.title : data.name}</h3>
                    <p>{content.kurzbeschreibung ? content.kurzbeschreibung : data.kurzbeschreibung}</p>
                    <ButtonLink to={data.url} variation={"minimal"}>{buttonLabel}</ButtonLink>
                </div>,
            });
        }

        if (data && references.length === 1) {
            items.push({
                top: <div key={data.url} className="container">   
                        <div className="columns">
                            <div className="column">
                                <GatsbyImage
                                    image={{...data.listenbild.src.childImageSharp.gatsbyImageData, aspectRatio: 1.6 }}
                                    alt={data.listenbild.alt}
                                    title={data.listenbild.alt} />
                            </div>

                            <div className="column">
                                    <div className="content">
                                        <h3 className="title">{content.title ? content.title : data.name}</h3>
                                        <p>
                                            {content.kurzbeschreibung ? content.kurzbeschreibung : data.kurzbeschreibung}
                                        </p>
                                    </div>
                                    <ButtonLink to={data.url}>{buttonLabel}</ButtonLink>
                            </div>
                        </div>

                    </div>,
                bottom: null,
            });
        }
    }

    return <Section id={id} hasTitle={true}>
        <div className="container">
            {title && <div className="content">
                <h3 className="title">{title}</h3>
            </div>}
            <div className="columns is-multiline">
                <div className="column">

                    {items.length > 1 && <Carousel
                        subPages={items.map((item) => item.bottom)}
                        startIndex={items.length > 2 ? 1 : 0}
                        >
                        {items.map((item) => item.top)}
                    </Carousel>}

                    {items.length === 1 && <Section size="extraSmall">
                        {items[0].top}
                    </Section>}

                </div>
               

            </div>
        </div>
    </Section>
    

}